module.exports = __webpack_public_path__ + "static/media/newsom.b5110763.png";